import { Button } from "@devhop/ui";
import { config } from "@/shared/lib/config";
import { fetchLookupForInfinite, hydrateLookupItems } from "@/shared/lib/utils";
import { InfiniteMultiCombobox } from "@/shared/ui/InfiniteMultiCombobox";

export type StaffOption = {
  id: string;
  name: string;
  defaultRoleLabel?: string | null;
};

type StaffMultiSelectProps = {
  label?: string;
  required?: boolean;
  values: string[];
  onValuesChange: (values: string[]) => void;
  lookupUrl?: string;
  queryKeyPrefix: string[];
  disabled?: boolean;
  hint?: string;
};

const DEFAULT_LOOKUP = `${config.apiUrl}/staff/lookup`;

export function StaffMultiSelect({
  label = "Staff",
  required,
  values,
  onValuesChange,
  lookupUrl = DEFAULT_LOOKUP,
  queryKeyPrefix,
  disabled,
  hint,
}: StaffMultiSelectProps) {
  return (
    <div className="flex min-h-0 w-full min-w-0 max-w-full flex-col gap-2">
      <div className="flex items-center justify-between gap-2">
        <p className="font-medium text-sm">
          {label}
          {required ? <span className="text-destructive"> *</span> : null}
        </p>
        {values.length > 0 ? (
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 px-2 text-xs"
            disabled={disabled}
            onClick={() => onValuesChange([])}
          >
            ລ້າງ
          </Button>
        ) : null}
      </div>

      <InfiniteMultiCombobox<StaffOption>
        className="w-full min-w-0 max-w-full"
        values={values}
        onValuesChange={onValuesChange}
        placeholder="ຄົ້ນຫາ ແລະ ເລືອກຫຼາຍ Staff..."
        queryKey={queryKeyPrefix}
        queryFn={({ search, pageParam }) =>
          fetchLookupForInfinite<StaffOption>(lookupUrl, {
            search,
            pageParam,
          })
        }
        preloadQueryFn={(ids) =>
          hydrateLookupItems<StaffOption>(lookupUrl, ids)
        }
        getLabel={(item) =>
          item.defaultRoleLabel
            ? `${item.name} · ${item.defaultRoleLabel}`
            : item.name
        }
        getValue={(item) => item.id}
        clearable
      />

      {values.length > 0 ? (
        <p className="text-muted-foreground text-xs">
          ເລືອກແລ້ວ {values.length} ຄົນ
        </p>
      ) : hint ? (
        <p className="text-muted-foreground text-xs">{hint}</p>
      ) : null}
    </div>
  );
}
